<template>
  <a-card class="m-display-flex flex-column nowrap">
    <span slot="title">PP Request Form</span>
    <a-steps :current="current" status="process">
      <a-step title="Information" />
      <a-step title="Financial Detail" />
      <a-step title="Purchasing Detail" />
      <a-step title="Approval" />
    </a-steps>
    <div class="steps-content flex-1">
      <component
        class="flex-1"
        :is="steps[current].content"
        :ref="stepRef"
        v-bind="stepProps"
      ></component>
    </div>
    <template class="ant-card-actions" slot="actions">
      <div class="steps-action">
        <a-button
          v-if="current < steps.length - 1"
          :disabled="mode == 'Edit' && disabledNext"
          type="primary"
          @click="next"
          >Next</a-button
        >
        <a-button
          :loading="loading"
          v-if="current == steps.length - 1"
          type="primary"
          @click="validate"
          >{{ mode == "Edit" ? "Save Changes" : "Save" }}</a-button
        >
        <a-button v-if="current > 0" @click="prev">Previous</a-button>
      </div>
    </template>
  </a-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import Informasi from "./steps/Informasi.vue";
import Keuangan from "./steps/Keuangan.vue";
import DetailPembelian from "./steps/DetailPembelian.vue";
import Persetujuan from "./steps/Persetujuan.vue";

export default {
  name: "PPCreate",
  props: ["id"],
  components: {
    Informasi,
    Keuangan,
    DetailPembelian,
    Persetujuan,
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: "Informasi",
          content: "Informasi",
        },
        {
          title: "Keuangan",
          content: "Keuangan",
        },
        {
          title: "DetailPembelian",
          content: "DetailPembelian",
        },
        {
          title: "Persetujuan",
          content: "Persetujuan",
        },
      ],
      mode: "Create",
      collectData: {},
      listPembelian: [],
      postData: new FormData(),
      postJson: {},
      editData: {},
      loading: false,
      projectAllsts: [],
      disabledNext: true,
      reference_id: null
    };
  },
  computed: {
    ...mapGetters(["getAuth"]),
    initialListItem() {
      let data = [];
      let hargaTotal = 0;
      // NEW
      this.listPembelian.forEach((item) => {
        hargaTotal = item.values.jumlah * item.values.harga;
        const values = item.values;
        data = [
          ...data,
          {
            hargaTotal: hargaTotal,
            path: item.values.path,
            id_anggaran: item.values.id_anggaran,
            values,
          },
        ];
      });

      // OLD
      // if (this.mode === "Edit") {
      //   this.listPembelian.forEach((item) => {
      //     hargaTotal = item.values.jumlah * item.values.harga;
      //     const values = item.values;
      //     data = [...data, { hargaTotal: hargaTotal, values }];
      //   });
      // } else {
      //   data = this.listPembelian;
      //   this.collectData.listBeli.forEach((item) => {
      //     hargaTotal = item.jumlah * item.harga;
      //     data = [
      //       ...data,
      //       {
      //         hargaTotal: hargaTotal,
      //         values: item,
      //       },
      //     ];
      //   });
      // }
      return data;
    },
    stepProps: function () {
      if (this.mode === "Edit") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            listPembelian: this.listPembelian,
            data: this.collectData.informasi,
            persetujuan: this.collectData.persetujuan,
            projectAllsts: this.projectAllsts,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "Keuangan") {
          return {
            listPembelian: this.listPembelian,
            data: this.collectData.keuangan,
            projectAllsts: this.projectAllsts,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "DetailPembelian") {
          return {
            listPembelian: this.initialListItem,
            keuangan: this.collectData.keuangan,
            informasi: this.collectData.informasi,
            infoUmum: this.collectData.infoUmum,
            mode: "Edit",
            mata_uang: this.collectData.keuangan.mata_uang,
            projectAllsts: this.projectAllsts,
          };
        } else if (this.steps[this.current].content === "Persetujuan") {
          return {
            data: this.collectData.persetujuan,
            informasi: this.collectData.informasi,
            approval: this.collectData.approval,
            projectAllsts: this.projectAllsts,
            mode: "Edit",
          };
        }
      } else if (this.mode === "Create") {
        if (this.steps[this.current].content === "Informasi") {
          return {
            listPembelian: this.listPembelian,
            data: this.collectData.informasi,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "Keuangan") {
          return {
            listPembelian: this.listPembelian,
            data: this.collectData.keuangan,
            mode: this.mode,
          };
        } else if (this.steps[this.current].content === "DetailPembelian") {
          return {
            listPembelian: this.listPembelian,
            keuangan: this.collectData.keuangan,
            informasi: this.collectData.informasi,
            infoUmum: this.collectData.infoUmum,
            mode: this.mode,
            mata_uang: this.collectData.keuangan.mata_uang,
          };
        } else if (this.steps[this.current].content === "Persetujuan") {
          return {
            data: this.collectData.persetujuan,
            informasi: this.collectData.informasi,
            mode: this.mode,
          };
        }
      }
      return true;
    },
    stepRef: function () {
      if (this.steps[this.current].content === "Informasi") {
        return "refInformasi";
      } else if (this.steps[this.current].content === "Keuangan") {
        return "refKeuangan";
      } else if (this.steps[this.current].content === "DetailPembelian") {
        return "refDetailPembelian";
      } else if (this.steps[this.current].content === "Persetujuan") {
        return "refPersetujuan";
      }
      return true;
    },
  },
  created() {
    if (this.id) {
      this.mode = "Edit";
      this.fetchDetail();
    }
  },
  methods: {
    ...mapActions(["FETCH_ALLOCATION", "FETCH_USEDFOR"]),
    next() {
      if (this.steps[this.current].content === "Informasi") {
        this.$refs.refInformasi.handleRef();
      } else if (this.steps[this.current].content === "Keuangan") {
        this.$refs.refKeuangan.handleRef();
      } else if (this.steps[this.current].content === "DetailPembelian") {
        this.$refs.refDetailPembelian.handleRef();
      }
    },
    prev() {
      this.current--;
    },
    validate() {
      this.$refs.refPersetujuan.handleRef();
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Informasi") {
        this.collectData.informasi = JSON.parse(
          JSON.stringify(value.informasi)
        );
        this.current++;
      } else if (this.steps[this.current].content === "Keuangan") {
        this.collectData.keuangan = JSON.parse(JSON.stringify(value.keuangan));
        this.current++;
      } else if (this.steps[this.current].content === "DetailPembelian") {
        this.collectData.estimated_value = JSON.parse(
          JSON.stringify(value.estimated_value)
        );
        if (this.mode !== "Edit") {
          this.collectData.informasi.approval = JSON.parse(
            JSON.stringify(value.approval)
          );
        }else{
          this.collectData.approval = JSON.parse(
            JSON.stringify(value.approval)
          );
        }
        this.current++;
      } else if (this.steps[this.current].content === "Persetujuan") {
        this.collectData.persetujuan = JSON.parse(
          JSON.stringify(value.persetujuan)
        );

        if (this.mode === "Edit") {
          this.confirmMessage("confirm-edit");
        } else {
          this.confirmMessage("confirm-save");
        }
      }
    },
    getListPembelian(item) {
      this.listPembelian = [
        ...this.listPembelian,
        JSON.parse(JSON.stringify(item)),
      ];

      this.$refs.refDetailPembelian.recountingAnggaran(this.listPembelian);
    },
    getUpdatePembelian(item) {
      this.listPembelian = item;
    },
    setSubmitForm() {
      let lkpd_id = [];
      let medical_claim_id = [];
      let ticket_id = [];
      let nama_barang = [];
      let jumlah = [];
      let satuan = [];
      let harga = [];
      let path = [];
      let kode_anggaran_dtl = [];
      let id_pp_dtl = [];
      let bailout_value = [];
      this.initialListItem.forEach((data) => {
        lkpd_id.push(data.values.lkpd_id?data.values.lkpd_id:'');
        medical_claim_id.push(data.values.medical_claim_id?data.values.medical_claim_id:'');
        ticket_id.push(data.values.ticket_id?data.values.ticket_id:'');
        nama_barang.push(data.values.nama_barang?data.values.nama_barang:'');
        jumlah.push(data.values.jumlah);
        satuan.push(data.values.satuan);
        harga.push(data.values.harga);
        path.push(data.values.path);
        kode_anggaran_dtl.push(data.values.kode_anggaran_dtl);
        id_pp_dtl.push(data.values.id_pp_dtl);
        bailout_value.push(data.values.bailout_value);
      });

      this.postJson = {
        tlc: this.getAuth.username,
        reference_id: this.reference_id,
        date_of_pp: this.collectData.informasi.tgl_buat,
        used_for: this.collectData.informasi.used_for.toString(),
        description: this.collectData.informasi.deskripsi,
        be_required: this.collectData.informasi.be_required,
        // lead_time: this.collectData.informasi.lead_time,
        lead_time: "-",
        end_user: this.collectData.informasi.end_user,
        kode_anggaran: this.collectData.informasi.kode_anggaran,
        pipeline: this.collectData.informasi.pipeline,

        mata_uang: this.collectData.keuangan.mata_uang,
        kurs_to_idr: this.collectData.keuangan.kurs_to_idr,
        downpayment: this.collectData.keuangan.downpayment,

        estimated_value: this.collectData.estimated_value,
        catatan: this.collectData.persetujuan.catatan
          ? this.collectData.persetujuan.catatan
          : "",
        lkpd_id: lkpd_id,
        medical_claim_id: medical_claim_id,
        ticket_id: ticket_id,
        nama_barang: nama_barang,
        jumlah: jumlah,
        satuan: satuan,
        harga: harga,
        kode_anggaran_dtl: kode_anggaran_dtl,
        path: path,
        id_pp_dtl: id_pp_dtl,
        bailout_value: bailout_value,
        type_activity: this.collectData.informasi.type_activity,
        activity: this.collectData.informasi.activity,
      };

      if(this.collectData.informasi.prospek){
        this.postJson['prospek'] = this.collectData.informasi.prospek
      }

      if (this.mode == "Edit") {
        this.postJson.id_pp = this.collectData.infoUmum.id_pp;
      } else {
        this.postJson.approval = this.collectData.persetujuan.approval;
      }
    },
    submit() {
      this.setSubmitForm();
      let method = "";
      if (this.mode === "Create") {
        method = "post";
      } else {
        method = "put";
      }

      this.loading = true;
      axios({
        method: method,
        url: this.$serviceUrl + "pp/v2",
        processData: false,
        data: this.postJson,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            this.displayMessage("success-save");
          } else {
            this.displayMessage("success-edit");
          }
          this.loading = false;
          this.current = 0;
          this.$router.go(-1);
        })
        .catch((err) => {
          let response = Object.assign({}, err.response.data);
          console.log(response);
          if (response.message === "DP tidak boleh melebihi estimasi") {
            this.displayMessage("error-dp-pp");
            this.loading = false;
          } else if (response.message === "Saldo Anggaran tak Mencukupi") {
            this.displayMessage("error-pp-over");
            this.loading = false;
          } else if (response.message) {
            this.displayMessageValue("error-other", response.message);
            this.loading = false;
          } else {
            console.log(response);
            this.displayMessageValue("error", response.message);
            this.loading = false;
          }
        });
    },
    async fetchDetail() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "pp/pp_Detil_v2",
        params: {
          id_pp: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let informasi = response.data.item_pp[1].informasi;
          //informasi.used_for = informasi.used_for.split(",");
          this.collectData = {
            infoUmum: response.data.item_pp[0],
            estimated_value: response.data.item_pp[0].estimated_value,
            informasi: informasi,
            keuangan: response.data.item_pp[2].keuangan,
            persetujuan: response.data.item_pp[3].persetujuan,
            listBeli: response.data.detil_pp,
            approval: response.data.approval_pp
          };

          response.data.detil_pp.forEach((item) => {
            this.listPembelian = [...this.listPembelian, { values: item }];
          });
        })
        .catch((err) => {
          console.log(err);
          this.displayMessage("error-aktif-project");
        });
      this.disabledNext = false;
    },
  },
  mounted() {
    this.FETCH_ALLOCATION();
    this.FETCH_USEDFOR();
    Event.$on("ppData", this.valueFromChild);
    Event.$on("listPembelian", this.getListPembelian);
    Event.$on("updateList", this.getUpdatePembelian);
    Event.$on("confirmMessageReturn", this.submit);
    this.reference_id = this.$route.query.ref_dtl;
  },

  beforeDestroy() {
    Event.$off("ppData", this.valueFromChild);
    Event.$off("listPembelian", this.getListPembelian);
    Event.$on("updateList", this.getUpdatePembelian);
    Event.$off("confirmMessageReturn", this.submit);
  },
};
</script>

<style></style>
